<template>
  <!-- Error boundary catches config validation errors and shows user-friendly message -->
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const converterConfig = parseAndValidateConverterConfig('lottie-to-apng-converter', 'Lottie → APNG');

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[Lottie APNG Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[Lottie APNG Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[Lottie APNG Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[Lottie APNG Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[Lottie APNG Converter] Credits updated:', credits);
}
</script>
